// set vue datepicker disabled-date
const isDateAfterToday = (ts) => {
  const d = new Date()
  d.setDate(d.getDate())
  d.setHours(0, 0, 0, 0)
  return ts > new Date(d.getTime())
}

const isDateAfterYesterday = (ts) => {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  d.setHours(0, 0, 0, 0)
  return ts > new Date(d.getTime())
}

export { isDateAfterToday, isDateAfterYesterday }
